import React from 'react'
const Weekly = () => {
  return (
    <>
    <div>
       THIS IS WEEKLY ANALYSIS PAGE
    </div>
    </>
  )
}
export default Weekly
